import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm, Field, Form } from 'redux-form/immutable';
import MenuItem from 'material-ui/MenuItem';
import FlatButton from 'material-ui/FlatButton';
import _ from 'lodash';
import {
  SelectField,
  TextField,
} from 'redux-form-material-ui';

import commonStyles from '../styles';
import styles from './styles';
import { showDialog, hideDialog } from '../../actions/dialogs';
import ReduxDialog from '../Common/ReduxDialog';
import Icon from '../Common/Icon';
import { required } from '../../utils/formvalidation';
import { renderJobProfileQualityControlQuestions } from '../../utils/reduxforms';
import { id } from '../../utils/helper';

const STAGE_TYPES = [
  {
  //   id: 'Basic',
  //   name: 'Basic',
  //   description: 'Basic',
  // }, {
    id: 'AddItems',
    name: 'Add Items',
    description: 'Add items to a task',
  }, {
    id: 'VerifyItems',
    name: 'Verify Items',
    description: 'Verify items are present',
  },
];

const RELATIVE_TO_LOCATIONS = [
  'origin',
  'destination',
]

class StageDialog extends Component {
  static propTypes = {
    stage: PropTypes.object,

    dialogs: PropTypes.object.isRequired,
    showDialog: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,

    onCancel: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
  };

  state = {};

  renderType = (type) => {
    return (<div style={styles.type}>
      <div style={styles.typeName}>{type.name}</div>
      <div style={styles.typeDesc}>{type.description}</div>
    </div>);
  };

  render() {

    const { handleSubmit, initialValues, submit, onCancel } = this.props;
    console.log('initialValu3es', initialValues);
    const actions = [
      <FlatButton
        label="Cancel"
        primary
        onClick={onCancel}
      />,
      <FlatButton
        label="Save"
        primary
        keyboardFocused
        onClick={() => submit('Stage')}
      />,
    ];

    return (
      <div>
        <ReduxDialog
          name="stage"
          title={initialValues && initialValues.get('id') ? initialValues.get('name') : 'Add Stage'}
          subTitle={'A task is comprised of one to many stages. Each stage represents a unique piece of work to be done by a specific team member.'}
          actions={actions}
          modal
          autoScrollBodyContent
          onRequestClose={this.handleCancel}
          contentStyle={styles.body}
        >
          <Form name="Stage" onSubmit={handleSubmit}>
            <div style={styles.container}>
              <div style={styles.content}>
                <div style={styles.row}>
                  {/*<Field*/}
                  {/*name="icon"*/}
                  {/*style={commonStyles.input}*/}
                  {/*component={SelectField}*/}
                  {/*floatingLabelText="Icon"*/}
                  {/*fullWidth>*/}
                  {/*{ icons.map((key) => <MenuItem key={key} value={key} style={styles.iconItem}>*/}
                  {/*<FontIcon className="material-icons" style={styles.icon}>{key}</FontIcon>*/}
                  {/*{ key.replace('_', ' ') }*/}
                  {/*</MenuItem>)}*/}
                  {/*</Field>*/}
                  {initialValues && initialValues.icon ? <Icon name={initialValues.icon} style={styles.icon}/> : null }
                  <div style={styles.column}>
                    <Field
                      name="name"
                      style={commonStyles.input}
                      component={TextField}
                      floatingLabelText="Name"
                      floatingLabelFixed
                      fullWidth
                      validate={[required]}
                    />
                    <Field
                      name="type"
                      style={commonStyles.input}
                      component={SelectField}
                      floatingLabelText="Type"
                      floatingLabelFixed
                      fullWidth
                      validate={[required]}>
                      { STAGE_TYPES.map((type) => <MenuItem
                        key={type.id}
                        value={type.id}
                        style={styles.iconItem}
                        label={type.name}
                      >{this.renderType(type)}</MenuItem>) }
                    </Field>
                    <Field
                      name="relativeTo"
                      style={commonStyles.input}
                      component={SelectField}
                      floatingLabelText="Location Relative To"
                      helpText="dfdsf"
                      floatingLabelFixed
                      fullWidth
                      validate={[required]}>
                      { RELATIVE_TO_LOCATIONS.map((location) => <MenuItem
                        key={location}
                        value={location}
                        label={location}
                      >{location}</MenuItem>) }
                    </Field>
                  </div>
                </div>
              </div>
              <div style={styles.content}>
                <Field
                  name="qualityControl.questions"
                  component={renderJobProfileQualityControlQuestions}
                  fullWidth
                />

                {/*<QuestionsTable*/}
                {/*questions={(initialValues.stage.qualityControl || {}).questions || []}*/}
                {/*onEdit={this.handleEditQualityControlQuestion}*/}
                {/*onRemove={this.handleRemoveQualityControlQuestion}/>*/}
                {/*<FloatingActionButton*/}
                  {/*style={styles.addQuestion}*/}
                  {/*onClick={() => this.handleEditQualityControlQuestion({})} secondary>*/}
                  {/*<ContentAdd />*/}
                {/*</FloatingActionButton>*/}
              </div>
            </div>
          </Form>
        </ReduxDialog>

      </div>
    );
  }
}

const form = reduxForm({
  form: 'Stage',  // a unique identifier for this form
  // validate,
  // asyncValidate
  // enableReinitialize: true,
  onSubmit: (values, dispatch, props) => {
    const stage = values.toJS();
    return props.onSave(_.assign({ id: id() }, stage));
  },
  onSubmitSuccess: (result, dispatch, props) => {
    props.hideDialog('stage');
  },
})(StageDialog);

function mapStateToProps(state, props) {
  const stage = state.getIn(['dialogs', 'dialogs', 'stage', 'context', 'stage']);
  console.log('input', stage);

  return {
    dialogs: state.get('dialogs').get('dialogs').toJS(),
    // stage: state.get('stages').get('stage').toJS(),
    initialValues: stage ? stage.toJS() : null,

    //   jobProfile: state.get('jobprofiles').get('jobProfile').toJS(),
    //   stage: props.stage || {},
    // },
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    // setQualityControlQuestion,
    // removeQualityControlQuestion: removeQualityControlQuestionRoutine.trigger,
    showDialog,
    hideDialog,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(form);



// WEBPACK FOOTER //
// ./src/components/StageDialog/index.js